<template>
  <div>
 <!-- Page Title-->
    <div class="page-title">
      <div class="container">
        <h1>Review</h1>
        <ul class="breadcrumbs">
          <li><router-link to="/home">Home</router-link>
          </li>
          <li class="separator">&nbsp;/&nbsp;</li>
          <li>Confirmation de la commande</li>
        </ul>
      </div>
    </div>
    <!-- Page Content-->
    <div class="container padding-bottom-3x mb-2">
      <div class="row">
        <!-- Checkout Shipping-->
        <div class="col-xl-9 col-lg-8">
          <h4>Vérifiez votre commande
</h4>
          <hr class="padding-bottom-1x">
          <div class="table-responsive shopping-cart mb-0">
            <table class="table">
              <thead>
                <tr>
                  <th>Référence (s)</th>
                  <th class="text-center">Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
               <hr class="padding-bottom-1x">
          <div class="d-flex justify-content-between">
    <router-link class="btn btn-outline-secondary m-0" to="/payment"><strong>Retour</strong></router-link>
    <button class="btn btn-primary m-0" @click="doCommande" :disabled="!commande||products.length===0">Confirmation finale</button>
    <!--<router-link class="btn btn-primary m-0" to="/complete">Complete Order</router-link>-->
    </div>
                <tr v-for="product in products" :key="product.id">
                  <td>
                    <div class="product-item">
                      <router-link @click.native="ProductDetail(product)"
                      class="product-thumb" to="/product">
                      <img :src="product.img" alt="Product"></router-link>
                      <div class="product-info">
                        <h4 class="product-title">
                          <router-link @click.native="ProductDetail(product)"
                          to="/product">{{product.id}}<small> x {{product.quantity}}</small></router-link>
                          </h4><span><em>Couleur:</em> {{product.color}}</span><span><em>Description:</em> <strong>{{product.description}}</strong></span>
                      </div>
                    </div>
                  </td>
                  <td class="text-center text-lg text-medium">{{product.price}} DA</td>
                  <td class="text-center"><router-link class="btn btn-outline-secondary btn-sm" to="/cart"><strong>Modifier</strong></router-link></td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="padding-bottom-1x">
          <div class="text-right padding-bottom-1x">Total: <span class='text-medium text-dark'>{{total}}</span></div>
          <div class="row padding-top-1x mt-3 mb-4">
            <div class="col-sm-6">
              <h5>Expédition à:</h5>
              <ul class="list-unstyled text-sm">
                <li><span class='text-muted'><strong>Client:</strong></span>{{firstName}} {{lastName}}</li>
                <li><span class='text-muted'><strong>Adresse:</strong></span> {{deliveryAddress}}</li>
                <li><span class='text-muted'><strong>Numéro de téléphone:</strong></span>{{phoneNumber}}</li>
              </ul>
            </div>
          </div>
         
        </div>
        <!-- Sidebar          -->
        <div class="col-xl-3 col-lg-4">
          <aside class="sidebar">
            <div class="padding-top-2x hidden-lg-up"></div>
            <!-- Order Summary Widget-->
            <section class="widget widget-order-summary bg-secondary border-0 p-4">
              <h3 class="widget-title"><strong> ÉCAPITULATIF DE LA COMMANDE</strong></h3>
              <table class="table text-sm mb-0">
                <tr>
                  <td><strong>Sous-total:</strong></td>
                  <td class="text-medium"><strong>{{total}} DA</strong></td>
                </tr>
                <tr>
                  <td><strong>Livraison  :</strong></td>
                  <td class="text-medium"><strong>0.00 DA</strong></td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-lg text-medium"><strong>{{total}} DA</strong></td>
                </tr>
              </table>
            </section>
            <!-- Promo Banner-->

          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
export default {
  computed: {
    status() {
      return this.$store.state.statusCode;
    },
    total() {
      return this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
    },
    commande() {
      //let current = this.$store.getters.getCommandeInfo;
      if (
        this.firstName === '' ||
        this.phoneNumber === '' ||
        this.lastName === ''||
        this.deliveryAddress === '' ||
        this.deliveryFirstName === '' ||
        this.deliveryLastName === ''

      )
        return false;
      return true;
    },
    ...mapGetters({ products: 'cartProducts' }),
    ...mapFields([
      'user.firstName',
      'user.lastName',
      'user.address',
      'user.phoneNumber',
      'user.email',
      'user.deliveryAddress',
      'user.billingAdress',
      'user.deliveryFirstName',
      'user.deliveryLastName',
      'user.deliveryPhoneNumber',
      'user.deliveryWilaya',
      'user.wilaya'
    ])
  },
  watch: {
    status() {
      if (this.status === 201) {
        /*this.$notify({
          group: 'cart',
          title: 'Commande',
          type: 'success',
          text: 'successfuly send commande to luxuryshop!'
        });*/
        this.$router.push('/complete');
      }
    }
  },
  methods: {
    doCommande() {
      this.$store.dispatch('doCommande');
    },
    ...mapActions(['ProductDettail'])
  }
};
</script>

<style scoped>
.page-title {
  margin-top: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/checkout/review.vue